/* Product summary is hidden on mobile */
.productInfo {
  display: none;
}

.weightButton {
  width: 45%;
  flex-grow: 1;
}

.textContrastColor {
  color: var(--colors-text-inverse);
}

@media (--reefer-media-tablet-min) {
  .productInfo {
    display: block;
    min-width: 512px;
  }

  .cancelButton {
    display: none;
  }
}
